<template>
  <div>
    <vs-button ref="loadBtn" color="secondary" type="border" @click="showLoadRiskPost = true">위험성평가 정보 불러오기</vs-button>
    <p style="font-size: 16px; line-height: 17px" class="mb-5">※ [<b>위험성평가</b>(유해·위험요인 파악) → <b>위험성평가회의</b>(위험성평가의 공유) → <b>교육·TBM 전파</b>(위험성 결정, 감소대책 수립) → <b>이행확인</b>(감소대책 실행)]</p>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="{ ...board, readonly: true }" :is-print="isPrint"  />

    <!-- 위험성평가 -->
    <RiskTable v-model="form.riskList" class="mb-6" readonly :isPrint="isPrint"/>

    <!-- ⑨ 일일TBM 활동 현황 -->
    <TMBTable
      class="mb-6"
      :readonly="!form.stdInfo.field_name || !form.headerDate || board.readonly"
      :prevTmbOption="prevTmbOption"
      :todayTmbOption="todayTmbOption"
      :isPrint="isPrint"
      v-model="form.tmbList"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- Post 불러오기 팝업 -->
    <PopupLoadPrevBoard title="위험성평가 정보 불러오기" :setBoardId="475" v-model="showLoadRiskPost" @selectRowData="loadRiskPost" />
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import RiskTable from "../475/RiskTable.vue";
import TMBTable from "./TMBTable.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    RiskTable,
    TMBTable,
    DateSelector,
    FileUploader,
    PopupLoadPrevBoard,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      headerDate: { required },
      stdInfo: {
        field_name: { required },
      },
    },
  },

  data() {
    return {
      showLoadRiskPost: false,
      form: {
        headerDate: "",
        stdInfo: {},
        fileList: [],
        riskList: [],
        tmbList: [],
        todayTmb: 0,

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {},
        inputA_6: "",
      },
      prevTmbOption: [],
      todayTmbOption: [],

      oldConditions: [],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    postId() {
      return this.$route.params.postId;
    },
    headerDate() {
      return moment(this.form.headerDate).format("YYYY-MM-DD");
    },
    postList() {
      const _postList = this.$store.state.board.postListInfo.data;
      if (_postList) return _postList.map((post) => this.getContent(post));
      else return [];
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        const date = value.date;
        this.form.headerDate = date;
      },
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        value.todayTmb = value.tmbList.reduce((acc, cur) => acc + Number(cur.input3), 0);
        this.$emit("input", value);
      },
    },
    'form.headerDate': {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadList();
        }
      }
    },
    'form.stdInfo.field_name': {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadList();
        }
      }
    },
  },
  mounted() {
    const buttonContainer = document.querySelector("#right-button-container");
    const loadBtn = this.$refs.loadBtn;
    buttonContainer.prepend(loadBtn.$el);
  },
  methods: {
    loadRiskPost(data) {
      this.form.tmbList = [];

      this.header.date = new Date(data.headerDate).format("yyyy-MM-dd");
      this.form.stdInfo = data.stdInfo;
      this.form.riskList = data.riskList;

      this.form.inputA_1 = data.inputA_1;
      this.form.inputA_2 = data.inputA_2;
      this.form.inputA_3 = data.inputA_3;
      this.form.inputA_4 = data.inputA_4;
      this.form.inputA_5 = data.inputA_5;
      this.form.inputA_6 = data.inputA_6;

      this.loadList();
    },
    // 내용불러오기
    async loadList() {
      if (!this.form.stdInfo.field_name || !this.form.headerDate) return;

      const projectId = this.projectId;
      const boardId = this.boardId;
      const page = 1;
      const perPage = 10000;

      const dateTarget = "body.headerDate";
      const dateBegin = `${moment(this.headerDate).format("YYYY")}-01-01`;
      const dateEnd = moment(this.headerDate).add(1, 'days').format("YYYY-MM-DD");
      const postId = this.postId;

      const conditions = []
      conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
      conditions.push({key: dateTarget, operator: '<', value: dateEnd})
      conditions.push({key: 'body.stdInfo.field_name', operator: '=', value: this.form.stdInfo.field_name})

      if (postId) {
        conditions.push({key: 'id', operator: '!=', value: postId})
      }

      if (JSON.stringify(this.oldConditions) === JSON.stringify(conditions)) return;
      this.oldConditions = JSON.parse(JSON.stringify(conditions));
      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        conditions
      });

      this.oldDataSetting();
    },
    oldDataSetting() {
      if (this.postList.length > 0) {
        const _prevDatas = [];
        const _todayDatas = [];
        this.postList.map((post) => {
          const today = moment(this.form.headerDate).format("yyyy-MM-DD");
          const headerDate = moment(post.headerDate).format("yyyy-MM-DD");
          if (post.tmbList && post.tmbList.length > 0) {
            post.tmbList.map((item) => {
              if (headerDate === today) {
                const _dataIndex = _todayDatas.findIndex((e) => e.type === item.input1_1);
                if (_dataIndex === -1) _todayDatas.push({ type: item.input1_1, value: Number(item.input3) });
                else _todayDatas[_dataIndex].value += Number(item.input3);
              } else {
                const _dataIndex = _prevDatas.findIndex((e) => e.type === item.input1_1);
                if (_dataIndex === -1) _prevDatas.push({ type: item.input1_1, value: Number(item.input3) });
                else _prevDatas[_dataIndex].value += Number(item.input3);
              }
            });
          }
        });
        this.prevTmbOption = _prevDatas;
        this.todayTmbOption = _todayDatas;
      } else {
        this.prevTmbOption = [];
        this.todayTmbOption = [];
      }
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.headerDate.required) return "날짜는 반드시 선택해야 합니다";
        if (!this.$v.form.stdInfo.field_name.required) return "위험성평가 정보는 반드시 불러와야 합니다";
      }
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
    onChangeDate(){
      this.form.tmbList = [];
      this.loadList();
    }
  },
};
</script>

<style scoped lang="scss"></style>
